<template>
    

    <div class='card purshase-product-info mb-4'>
        
        <div  class='card-header product-name '>
            <div class='index' v-if="index > 0"> {{ index }} </div>
            <h5 class='name'> {{product.fullname.replace(/^[^\/]*?\//,'')}} </h5> 
            <ico class='delete' @click="removePurshaseProduct" icon='trash'></ico>
        </div>

        <div class='info card-body'>
            <team-list :team="team"></team-list>
            <div >
            <collapse class="" showOpen>
                <div class='  mt-1 w-100 mt-4 col-12 offset-lg-2 col-lg-8' slot="header-close">
                        <h5>   <ico icon="user-friends"/> Editar Atletas </h5>
                </div>
                <div class='   mt-1 w-100 mt-4 col-12 offset-lg-2 col-lg-8' slot="header-open">
                         <h5>   <ico icon="user-friends"/> Atletas</h5>
                </div>
                <hr class='mb-4' />
                <!-- <div class='info card-body tc gray' slot="body-on-close">
                        -- Clique para preencher --
                </div> -->
                <member-list :members="members"></member-list>
            </collapse>
            </div>
        </div>

    </div>

</template>

<script>
export default {
    data(){
        return {
            open:false
            }
    },
    props:{
        purshaseProduct:{
            type:Object
        },
        index:{
            type:Number,
            default:0
        }
    },

    computed:{
        product:function(){
            return this.purshaseProduct.product;
        },
        members:function(){
            return this.purshaseProduct.members;
        },
        team:function(){
            return this.purshaseProduct.team;
        },
        needFill:function(){
            return this.purshaseProduct.teamDefinitions.needFillOnPurchase;
        },
    },

    methods:{
        removePurshaseProduct:function(){
            this.$store.commit('OrderStore/removePurchaseProduct',this.purshaseProduct)
        }
    }
}
</script>

<style lang="stylus">

.product-name{
    position:relative;
    background var(--product-selector-bg-color);

    .index{
        position:absolute;
        width larg = 25px;
        height: larg
        border-radius:25px 0 0 25px;
        left:-(larg);
        top:2px;
        background:var(--product-selector-color)
        line-height: larg;
        color:white;
        font-weight:bolder;
        text-align:center;
        // opacity:0.6;
    }
    .name{
        color:white;
    }
    .delete{
        position:absolute;
        color:white;
        right:15px;
        top:15px;
        opacity:0.9;
        cursor:pointer;
    }    
}

</style>
